import AjusteVerbaListBotoes from '../../produto/spa/ajuste-verba/AjusteVerbaListBotoes';

export default AjusteVerbaListBotoes;
